export type Theme = {
  color: string
  colorHover: string
  colorBackground: string
  colorGray70to100: string
  colorGray80to90: string
  //  text-gray-90: string
  colorGray100to70: string
  colorWhite: string
  colorWhiteToBlack: string
  colorBlackToWhite: string
  colorError: string
  colorSwitch: string
  colorYellow: string
  colorLightYellow: string
  colorGreen: string
}

export const darkTheme: Theme = {
  color: '#ff9736', // rgba(255, 151, 53, 1)
  colorHover: '#ff8c02', // rgba(255, 140, 0, 1)
  colorBackground: '#000000', // rgba(21, 21, 21, 1)
  colorGray70to100: '#f6f6f6', // rgba(246, 246, 246, 1)
  colorGray80to90: '#B1B1B1',
  //  text-gray-90: '#727272',
  colorGray100to70: '#262626', // rgba(38, 38, 38, 1)
  colorWhite: '#FFFFFF', // rgba(255, 255, 255, 1)
  colorWhiteToBlack: '#FFFFFF', // rgba(255, 255, 255, 1)
  colorBlackToWhite: '#151515', // rgba(21, 21, 21, 1)
  colorError: '#e72358', // rgba(231, 34, 88, 1),
  colorSwitch: '#272727', // "rgba(78, 78, 78, 0.3) on background #151515", // https://rgbacolorpicker.com/rgba-to-hex
  colorYellow: '#ffee35', // 'rgba(255, 238, 53, 1)',
  colorLightYellow: 'rgba(252, 255, 162, 1)',
  colorGreen: 'rgb(57, 201, 0)'
}

export const lightTheme: Theme = {
  color: '#ff9736', // rgba(255, 151, 53, 1)
  colorHover: '#ff8c02', // rgba(255, 140, 0, 1)
  colorBackground: '#fcfbfc',
  colorGray70to100: '#262626', // rgba(38, 38, 38, 1)
  colorGray80to90: '#727272',
  //  text-gray-90: '#B1B1B1',
  colorGray100to70: '#ebebeb', // rgba(235, 235, 235, 1)
  colorWhite: '#FFFFFF', // rgba(255, 255, 255, 1)
  colorWhiteToBlack: '#151515', // rgba(21, 21, 21, 1)
  colorBlackToWhite: '#FFFFFF', // rgba(255, 255, 255, 1)
  colorError: '#e72358', // rgba(231, 34, 88, 1)
  colorSwitch: '#D1D1D1', // "rgba(199, 199, 199, 0.8) on background #fcfbfc", // https://rgbacolorpicker.com/rgba-to-hex
  colorYellow: 'rgba(255, 238, 53, 1)',
  colorLightYellow: '#F4F880',
  colorGreen: 'rgb(57, 201, 0)'
}
